import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Plus, User } from 'lucide-react'
import { Api } from '../lib/api.js'
import { useAuth } from '../contexts/AuthContext.jsx'
import { env } from '../config/env.js'
import Button from '../components/ui/Button.jsx'
import Card from '../components/ui/Card.jsx'

export default function ClientsListPage() {
  const { token, onUnauthorized } = useAuth()
  const nav = useNavigate()
  const [clients, setClients] = useState(null)
  const [err, setErr] = useState(null)

  useEffect(() => {
    const api = new Api({ baseURL: env.API_BASE_URL || '', getToken: () => token, onUnauthorized })
    api.listClients().then(setClients).catch((e) => setErr(e.message))
  }, [token, onUnauthorized])

  return (
    <div className="px-4 py-6 sm:px-7 sm:py-8 md:px-12 lg:px-20">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-[22px] font-semibold tracking-[-0.02em]">Clients</h1>
        <Button onClick={() => nav('/clients/new')}>
          <Plus size={14} strokeWidth={2.4} /> Nouveau client
        </Button>
      </div>

      {err && <div className="mb-4 rounded-lg border border-terra-500/40 bg-terra-50 px-4 py-3 text-[12.5px] text-terra-600">{err}</div>}
      {clients === null && <div className="text-[12.5px] text-muted">Chargement…</div>}
      {clients?.length === 0 && (
        <Card className="px-8 py-10 text-center">
          <p className="text-[14px] font-medium">Aucun client pour l'instant.</p>
          <p className="mt-1 text-[12.5px] text-muted">Cliquez sur « Nouveau client » pour commencer.</p>
        </Card>
      )}
      {clients?.length > 0 && (
        <ul className="space-y-2">
          {clients.map((c) => (
            <li key={c.ID || c.id}>
              <Link
                to={`/clients/${c.ID || c.id}`}
                className="flex items-center justify-between gap-2 rounded-xl border border-line bg-white px-4 py-3.5 hover:border-terra-500 sm:px-5"
              >
                <div className="flex min-w-0 items-center gap-3">
                  <span className="shrink-0 rounded-full bg-bg p-2"><User size={14} /></span>
                  <div className="min-w-0">
                    <div className="truncate text-[14px] font-semibold">{c.Name || c.name}</div>
                    <div className="truncate text-[11.5px] text-muted">{c.Email || c.email}</div>
                  </div>
                </div>
                <div className="shrink-0 text-[11px] text-muted">{c.Phone || c.phone || ''}</div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
